

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _squid = require('squid');

var _index = require('xo-models/src/checkout/index');

var _util = require('xo-return-to-merchant/dist/util');

var _icFallback = require('./icFallback');

var _integration = require('./integration');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fallbackErrorHandler', function () {
    return function (err) {
        var reason = err && err.reason;
        var entry_point = err && err.entryPoint;
        var params = err && err.params;
        var model = {};
        var product = err && err.product;
        var isWpsSubscription = void 0;
        var isWpsInstallmentPlan = void 0;

        function getFallbackUrl(urlParams, waType) {
            if (_angular.$rootScope.wps || _angular.$rootScope.invoice) {
                return (0, _squid.$populate)(model, {
                    checkoutAppData: _index.$CheckoutAppDataModel.instance(_squid.$meta.token)
                }).then(function () {
                    // defaulting for now to ensure backward compatibility
                    var base = _squid.$config.urls.fallbackUrl['buyNow'];

                    if (model.checkoutAppData.flags.is_cart_upload_flow || waType === 'CartUpload' || waType === 'AddToCart' || model.checkoutAppData.flags.is_shopping_cart_flow || waType === 'ShoppingCart') {
                        base = _squid.$config.urls.fallbackUrl['cartUpload'];
                    }

                    if (model.checkoutAppData.flags.is_invoice_flow) {
                        urlParams.id = model.checkoutAppData.invoice_id;
                        base = _squid.$config.urls.fallbackUrl['invoice'];
                    }

                    if (isWpsSubscription) {
                        base = _squid.$config.urls.fallbackUrl['wpsSubscription'];
                    }

                    if (isWpsInstallmentPlan) {
                        base = _squid.$config.urls.fallbackUrl['wpsInstallmentPlan'];
                    }

                    return _squid.$util.paypalURL(base, urlParams);
                });
            } else {
                return _angular.$q.when().then(function () {
                    var base = _squid.$config.urls.fallbackUrl[product];

                    return _squid.$util.paypalURL(base, urlParams);
                });
            }
        }

        function showGenericErrorPage(errorReason) {
            if (_angular.$rootScope.partnerIntegration) {
                _logger.$logger.info('partner_integration_fallback_to_genericErrorPage');
            }

            var code = errorReason || reason;

            code = code ? window.btoa(code) : code;

            _uiRouter.$state.go('checkout.genericError', {
                code: code
            });
        }

        function handleFallbackRedirect(url, wpsParams) {
            if (!_squid.$config.fallbackEnabled && !entry_point) {
                return _logger.$log.warn('Fallback inhibited by config', url);
            }

            if (_squid.$config.deploy.isLocal() && !entry_point) {
                return _logger.$log.warn('Fallback inhibited in local mode.', url);
            }

            _logger.$logger.log(product ? 'info' : 'error', 'fallback', {
                reason: reason,
                product: product,
                entry_point: entry_point,
                error_desc: reason,
                from: _angular.$rootScope.currentState || 'fallback',
                to: product ? 'process_fallback_' + product : 'process_fallback'
            });

            _logger.$logger.info('fallback_reason_' + reason, {
                reason: reason
            });
            _logger.$logger.info('build_' + _squid.$meta.buildId + '_fallback_reason_' + reason); // release vs live traffic separation

            if (window.xchild) {
                if (window.opener) {
                    return (0, _icFallback.$incontextFallback)(window, url);
                }

                return _uiRouter.$state.go('checkout.framebust', { action: 'fallback', url: url });
            }

            _angular.$rootScope.$emit('loading');

            if (product === 'ux') {
                // Otherwise we can make a decision based on whether we're in the minibrowser or not
                return _angular.$rootScope.wps && !_angular.$rootScope.invoice ? _util.$ReturnToMerchant.postTo(url, wpsParams) : _util.$ReturnToMerchant.goTo(url);
            }

            // Safe to always return to Aries
            return _squid.$util.redirect(url);
        }

        function doFallback() {
            _squid.$util.assert(reason, 'expected fallback reason');

            product = product || 'ux';

            var urlParams = params || {};

            _angular2['default'].extend(urlParams, {
                token: _squid.$meta.token,
                fallback: 1,
                reason: reason,
                landing: entry_point,
                useraction: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token).useraction()
            });

            if (_angular.$rootScope.partnerIntegration) {
                urlParams.incontext = '1';
                urlParams.nolegacy = '1';
            } else if (_angular.$rootScope.miniBrowser) {
                urlParams.incontext = '1';
            }

            var wpsParams = void 0;

            if (_angular.$rootScope.wps) {
                wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
                _logger.$logger.info('wps_fallback', {
                    token: _squid.$meta.token,
                    reason: reason
                });
                _logger.$logger.info('wps_fallback_reason_' + reason, {
                    reason: reason
                });
                _logger.$logger.info('build_' + _squid.$meta.buildId + '_wps_fallback_reason_' + reason); // release vs live traffic separation
            }

            var waType = wpsParams && wpsParams.wa_type;

            return getFallbackUrl(urlParams, waType).then(function (url) {
                // Fallback whitelist error reason in config to determine if we should fallback or instead redirect to generic error page.
                var fallbackWhitelist = _squid.$config.fallbackWhitelist;
                var whitelist = fallbackWhitelist && fallbackWhitelist.whitelisted || [];

                // if error reason not in fallback whitelist, try auto-retry
                if (whitelist && whitelist.indexOf(reason) === -1) {
                    var AUTORELOAD_LIMIT = 1; // can be increased later
                    // get auto reload count from params - if present
                    var autoReloadCount = parseInt(_squid.$util.param('arc'), 10);

                    // if falsy (NaN or 0)...
                    if (!autoReloadCount) {
                        // start at zero
                        autoReloadCount = 0;
                    }
                    // if we haven't reloaded _enough_ yet...
                    if (autoReloadCount < AUTORELOAD_LIMIT) {
                        // bump count
                        autoReloadCount++;
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'error_auto_reload',
                            'to': 'restart_hermes_app',
                            'int_error_code': reason
                        });

                        // pass params, so url is augmented
                        _squid.$util.replace({ arc: autoReloadCount });
                    } else {
                        // If auto reload didn't fix the error - redirect to error page with retry option
                        var RETRY_KEY = 'retry_page_shown';
                        var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
                        var timesSeen = Number(sessionStorage.getItem(RETRY_KEY));
                        var destination = 'RETRY';
                        var transition_name = 'show_retry_page';

                        // Reset if there's an invalid value for timesSeen for some reason
                        if (!timesSeen || timesSeen < 0) {
                            timesSeen = 0;
                        }

                        // Only try to go to retry page if we're within retry attempts
                        if (timesSeen < RETRY_PAGE_LIMIT) {
                            timesSeen++;
                            sessionStorage.setItem(RETRY_KEY, timesSeen);
                        } else {
                            destination = 'DEFAULT';
                            transition_name = 'show_error_page';
                        }

                        _logger.$logger.info('checkout_fpti', {
                            'from': 'error_auto_reload',
                            'to': transition_name,
                            'enable_refresh_prompt': reason,
                            'int_error_code': reason
                        });
                        return showGenericErrorPage(destination);
                    }
                } else {
                    _logger.$logger.info('fallback_reason_whitelisted', {
                        reason: reason,
                        product: product
                    });
                    handleFallbackRedirect(url, wpsParams);
                }
            });
        }

        if (product === 'error') {
            _logger.$logger.error(reason, {
                url: window.location.href
            });

            var _$config$urls = _squid.$config.urls,
                baseUrl = _$config$urls.baseUrl,
                errorUrl = _$config$urls.errorUrl;


            return _squid.$util.redirect(baseUrl + errorUrl);
        }

        if (_integration.$integration.getConfig('ERROR_AFTER_PAYMENT') && _angular.$rootScope.paymentComplete) {
            // Do not fallback. UX has no context of hermes token and will result in duplicate payment
            _logger.$logger.info('wps_error_after_payment', {
                reason: reason
            });

            return showGenericErrorPage('PAYMENT_ALREADY_DONE');
        }

        var beamPattern = /^BA-[0-9A-Z]{17}$/;
        var isBeamIntegration = _squid.$meta.baToken && beamPattern.test(_squid.$meta.baToken);
        var cartExchangeFailed = isBeamIntegration && beamPattern.test(_squid.$meta.token);

        if (cartExchangeFailed) {
            product = 'ux';
        }

        // For Beam Integration - always show generic Error when cart exchange fails.
        // On successful Cart Exchange - disable fallback until MPWEB supports BA token support.
        if (product === 'ux' && isBeamIntegration && cartExchangeFailed) {
            return showGenericErrorPage();
        }

        return (0, _squid.$populate)(model, {
            checkoutCart: _index.$CheckoutCartModel.instance(_squid.$meta.token),
            checkoutAppData: _index.$CheckoutAppDataModel.instance(_squid.$meta.token)
        }).then(function () {
            isWpsSubscription = model.checkoutAppData.is_wps_subscription_flow();
            isWpsInstallmentPlan = model.checkoutAppData.is_wps_installmentplan_flow();
            var merchantCountry = model.checkoutAppData.merchant.merchant_country;
            var isSecondButtonTxn = model.checkoutAppData.is_second_button_txn;

            // No fallback for Tokenized_Wallet usecases
            if (model.checkoutCart.isWalletTokenization()) {
                return showGenericErrorPage();
            }

            // No fallback for DE second button transactions
            if (merchantCountry === 'DE' && isSecondButtonTxn) {
                return showGenericErrorPage();
            }

            // Do not fallback if appdata flag dictates no fallback
            if (model.checkoutAppData.flags.disable_legacy_fallback) {
                _logger.$logger.error('fallback_inhibited_for_xo_order_tokens');
                return showGenericErrorPage();
            }

            // V.zero - fallback resize before do actual fallback
            if (product === 'ux' && _angular.$rootScope.partnerIntegration) {
                _logger.$logger.info('partner_integration_fallback_to_UX');
                _angular.$window.resizeTo(screen.availWidth, screen.availHeight);
            }

            // default do fallback (not actually fallback) - check doFallback() to understand it better
            return doFallback();
        })['catch'](showGenericErrorPage);
    };
});

_uiRouter.$state;

_logger.$log;

_logger.$logger;

_squid.$config;

_squid.$meta;

_squid.$populate;

_squid.$util;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_util.$ReturnToMerchant;

_icFallback.$incontextFallback;

_integration.$integration;


//////////////////
// WEBPACK FOOTER
// ./js/lib/fallback.js
// module id = ./js/lib/fallback.js
// module chunks = main-code-split